import React, { useEffect, useState } from 'react'
import { Form, Input, Button, message, Switch } from 'antd-v4'
import { LocalStorage } from '../../../utilities/LocalStorage'
import { AppType, GlobalStore } from '../../../stores/GlobalStore'
import { COLORS } from '../../../constants/Colors'

export const AdminDevelopmentSettings = () => {
  const [form] = Form.useForm()
  const [isBlaze, setIsBlaze] = useState(GlobalStore.appType === AppType.BLAZEPOS)
  const isLocalhost =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '::1'

  useEffect(() => {
    const apiUrl = LocalStorage.getOverrideAPIUrl()
    if (apiUrl) {
      form.setFieldsValue({ apiUrl })
    }
  }, [])

  const onFinish = (values: { apiUrl: string }) => {
    LocalStorage.setOverrideAPIUrl(values.apiUrl)
    message.success('API URL updated')
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
    message.error('Failed to update API URL')
  }

  return (
    <Form
      form={form}
      name='basic'
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete='off'
    >
      {isLocalhost && (
        <Form.Item label='App Type'>
          <Switch
            checked={isBlaze}
            checkedChildren='R-Series'
            unCheckedChildren='Greenline'
            style={!isBlaze ? { backgroundColor: COLORS.green500 } : undefined}
            onChange={(nextIsBlaze) => {
              setIsBlaze(nextIsBlaze)
              LocalStorage.setAppTypeOverride(nextIsBlaze ? AppType.BLAZEPOS : AppType.GREENLINE)
            }}
          />
        </Form.Item>
      )}
      <Form.Item label='API URL' name='apiUrl'>
        <Input placeholder={process.env.REACT_APP_ROOT_API_URL} allowClear />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button type='primary' htmlType='submit'>
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}
